import { Address } from '@vfde-sails/avc-core';
import { AddressValidationActions } from './enum';
import { AddressForm } from './interface';
import { JarvisResponse } from '../../interface';

export const setForm = (form: Partial<AddressForm>) => ({
    type: AddressValidationActions.SET_FORM,
    form,
} as const);

export const setSelectedAddress = (index: string | number) => ({
    type: AddressValidationActions.SET_SELECTED_ADDRESS,
    index: +index,
} as const);

export const setAddresses = (addresses: Address[]) => ({
    type: AddressValidationActions.SET_ADDRESSES,
    addresses,
} as const);

export const setJarvisResponse = (response: JarvisResponse) => ({
    type: AddressValidationActions.SET_JARVIS_RESPONSE as const,
    response,
});

export const setJarvisError = (error: unknown) => ({
    type: AddressValidationActions.SET_JARVIS_ERROR as const,
    error,
});

export const checkAddress = (isSeamless: boolean = false) => ({
    type: AddressValidationActions.CHECK_ADDRESS,
    isSeamless,
} as const);

export const deleteAddress = () => ({
    type: AddressValidationActions.DELETE_ADDRESS,
} as const);

export const changeAddress = () => ({
    type: AddressValidationActions.CHANGE_ADDRESS,
} as const);

export type Actions = ReturnType<typeof setForm>
    | ReturnType<typeof setSelectedAddress>
    | ReturnType<typeof setAddresses>
    | ReturnType<typeof setJarvisResponse>
    | ReturnType<typeof setJarvisError>
    | ReturnType<typeof checkAddress>
    | ReturnType<typeof deleteAddress>
    | ReturnType<typeof changeAddress>
    | ReturnType<typeof checkAddress>;
